import { api } from '@cwd/lib/main';

// Backs the ObjectConfiguration field's assistant in the Connection form
// (claude_plans/salesforce-import-plan.md §11). Takes credentials directly,
// not a ConnectionId - this runs while adding/editing a connection, before
// its current form values are necessarily saved.
export interface SalesforceCredentialsInput {
    AuthFlow: string;
    InstanceUrl: string;
    ApiVersion: string;
    ClientId: string;
    ClientSecret: string;
    Username: string;
    Password: string;
    PrivateKeyPem: string;
}

export interface SalesforceObjectSummary {
    Name: string;
    Label: string;
    Custom: boolean;
}

export interface SalesforceFieldOption {
    Name: string;
    Label: string;
    Type: string;
    // Object API name(s) this field points to when Type is "reference" - empty
    // for every other field. Lets "field that links to X" pickers show only
    // fields that actually can (claude_plans/salesforce-import-plan.md §11).
    ReferenceTo: string[];
    Updateable: boolean;
}

// The reverse of ReferenceTo: another object's field that points AT the
// object this was fetched for. Comes from Salesforce's own describe response
// (childRelationships), same call as the fields above, no extra fetch.
export interface SalesforceChildRelationship {
    ChildObject: string;
    Field: string;
}

export interface SalesforceObjectDescribeSummary {
    Fields: SalesforceFieldOption[];
    ChildRelationships: SalesforceChildRelationship[];
}

// POST /Salesforce/DiscoverObjects - every queryable object in the org
export const discoverSalesforceObjects = (credentials: SalesforceCredentialsInput): Promise<SalesforceObjectSummary[]> =>
    api.post('/Salesforce/DiscoverObjects', credentials);

// POST /Salesforce/DiscoverObjects/{objectName}/Fields
export const discoverSalesforceObjectFields = (objectName: string, credentials: SalesforceCredentialsInput): Promise<SalesforceObjectDescribeSummary> =>
    api.post(`/Salesforce/DiscoverObjects/${encodeURIComponent(objectName)}/Fields`, credentials);
